import { Component, OnInit, Input } from "@angular/core";
import {
  UntypedFormGroup,
  UntypedFormArray,
  UntypedFormControl,
  UntypedFormBuilder,
  Validators,
  Form,
} from "@angular/forms";

import { Constants } from "../../constants/gsfCalc-constants";
import { GSFReport } from "../../GSF-report.service";

@Component({
  selector: "app-table",
  templateUrl: "./table.component.html",
  styleUrls: ["./table.component.css"],
})
export class TableComponent implements OnInit {
  @Input() activity;
  @Input() activityForm: UntypedFormGroup;
  @Input() reportSubmissionId;
  @Input() tableLevelReportCtl: UntypedFormControl;
  @Input() wasteReductionobj;

  categoryMaterialWise = {};
  materialList = [];
  managementPracticeType = [];
  wasteFormGroup: UntypedFormGroup;

  constructor(
    public report: GSFReport,

    private readonly fb: UntypedFormBuilder
  ) {}

  ngOnInit() {
    this.materialList = Object.keys(this.wasteReductionobj.materialTypes);
    this.managementPracticeType = Object.keys(
      this.wasteReductionobj.managementPracticeTypes
    );
    this.createWasteFormGroup();

    this.materialList.forEach((material) => {
      this.categoryMaterialWise[material] = Object.keys(
        this.wasteReductionobj.materialTypes[material].category
      );
    });
    this.onChanges();
  }

  getIpControl(matInd, catInd): UntypedFormControl {
    const materialGp = this.getMaterialGp(matInd) as UntypedFormGroup;
    return this.getCatCtl(materialGp, catInd);
  }
  getRoundOf(report): number {
    return Math.round(report * 10) / 10;
  }
  onChanges(): void {
    const materialFormArr = this.wasteFormGroup.get(
      "metrialGroupList"
    ) as UntypedFormArray;
    const materialFormGpList = materialFormArr.controls;
    const grandTotal = this.getGrandTotal(materialFormArr);
    this.tableLevelReportCtl.setValue(grandTotal);
    this.wasteReductionobj.grandTotal = this.getRoundOf(grandTotal);
    materialFormGpList.forEach((materialGp) => {
      const matGp = materialGp as UntypedFormGroup;
      const subTotal = matGp.get("totalGeneratedTons") as UntypedFormControl;
      subTotal.valueChanges.subscribe((val) => {
        this.report.gsfValid = true;
        const tableTotalReport = this.getGrandTotal(materialFormArr);
        this.tableLevelReportCtl.setValue(tableTotalReport);
        this.wasteReductionobj.grandTotal = tableTotalReport;
      });
    });
  }
  updateActivityStatus(): void {
    this.activity.status = Constants.MODIFIED;
    this.activityForm.markAsTouched();
  }
  private createWasteFormGroup(): void {
    this.wasteFormGroup = this.fb.group({
      grandTotalReport: this.fb.control(0, Validators.required),
      metrialGroupList: this.fb.array([]),
    });

    const materials = Object.keys(this.wasteReductionobj.materialTypes);
    if (materials.length > 0) {
      materials.forEach((wasteRdType) => {
        const control = this.wasteFormGroup.get(
          "metrialGroupList"
        ) as UntypedFormArray;
        control.push(this.metrialTypeGroup(wasteRdType));
      });
    }
  }
  private createCatControl(wasteRdType, cat): UntypedFormControl {
    const value = this.wasteReductionobj.materialTypes[wasteRdType].category[
      cat
    ].value;
    return this.fb.control(value, Validators.required);
  }
  private getMaterialGp(materialInd): any {
    const materialFormArr = this.wasteFormGroup.get(
      "metrialGroupList"
    ) as UntypedFormArray;
    return materialFormArr.controls[materialInd];
  }

  private getCatCtl(materialForm: UntypedFormGroup, catInd): any {
    const catCtlArray = materialForm.get("categeyControls") as UntypedFormArray;
    return catCtlArray.controls[catInd];
  }

  private getGrandTotal(materialFormGpList: UntypedFormArray): number {
    let grandTotal = 0;
    materialFormGpList.controls.forEach((mat) => {
      grandTotal = grandTotal + mat.get("totalGeneratedTons").value;
    });
    return this.getRoundOf(grandTotal);
  }

  private metrialTypeGroup(wasteRdType): UntypedFormGroup {
    const materialFormGp = this.fb.group({
      categeyControls: this.fb.array([]),
      totalGeneratedTons: this.fb.control(0),
      materialName: this.fb.control(wasteRdType),
    });

    let subTotal = 0;
    const categerys = Object.keys(
      this.wasteReductionobj.materialTypes[wasteRdType].category
    );
    categerys.forEach((cat) => {
      const control = materialFormGp.get("categeyControls") as UntypedFormArray;
      control.push(this.createCatControl(wasteRdType, cat));
      const report = this.wasteReductionobj.materialTypes[wasteRdType].category[cat].value;
      if (report !== "NA" && report !== "") {
        subTotal = subTotal + parseInt(report);
      }
    });

    materialFormGp.get("totalGeneratedTons").setValue(subTotal);
    return materialFormGp;
  }
}

